import { EmailDetails } from "@models/bulkemailing/emailDetails";
import { EmailRepo } from "@services/email.repo";
import { EmailStatus } from "@models/portfolioadmin/reportManagement/emailStatus";

interface TableColumn {
  key: string;
  label: string;
  width?: string;
  type?: 'text' | 'date' | 'checkbox' | 'boolean' | 'currency' | 'percentage' | 'html';
}

class EmailsController implements angular.IOnInit {
  public emails: any[]
  public loading: boolean = true;
  public tableColumns: TableColumn[] = [
    { key: 'subject', label: 'Subject', width: 'col-md-4' },
    { key: 'dateSent', label: 'Date Sent', width: 'col-md-2', type: 'date' },
    { key: 'sentBy', label: 'User', width: 'col-md-2' },
    { key: 'recipientCount', label: 'No. Of Recipients', width: 'col-md-2' },
    { key: 'status', label: 'Status', width: 'col-md-4', type: 'html' }
  ];

  /** @ngInject */
  constructor(private $window: angular.IWindowService, private $state: angular.ui.IStateService,
    private $mdDialog: angular.material.IDialogService, private $rootScope: angular.IRootScopeService, private emailRepo: EmailRepo) { }

  $onInit(): void {
    this.loadEmails();
    
    // Listen for refresh events
    this.$rootScope.$on('refresh-email-list', () => {
      this.loadEmails();
    });
  }

  private loadEmails(): void {
    this.loading = true;
    this.emailRepo.getGroupEmails()
      .then(emails => {
        this.emails = emails.map((e: any) => {
          const recipients = e.Recipients || e.recipients || [];
          const attachments = e.Attachments || e.attachments || [];
          const sendingCount = recipients.filter((r: any) => {
            const status = r.EmailStatus || r.emailStatus || r.Status;
            return status === EmailStatus.SENDING || status === EmailStatus.PENDING;
          }).length;
          const sentCount = recipients.filter((r: any) => {
            const status = r.EmailStatus || r.emailStatus || r.Status;
            return status === EmailStatus.SENT;
          }).length;
          const failedCount = recipients.filter((r: any) => {
            const status = r.EmailStatus || r.emailStatus || r.Status;
            return status === EmailStatus.FAILED;
          }).length;

          return {
            emailId: e.EmailId || e.emailId || e.Id,
            subject: e.Subject || e.subject,
            message: e.Message || e.message,
            dateSent: e.DateSent || e.dateSent,
            sentBy: e.SentBy || e.sentBy,
            recipients: recipients.map((r: any) => ({
              recipientId: r.RecipientId || r.recipientId || r.Id || r.id,
              email: r.Email || r.email || r.emailAddress,
              emailStatus: r.EmailStatus || r.emailStatus || r.Status
            })),
            attachments: attachments.map((a: any) => ({
              attachmentId: a.AttachmentId || a.attachmentId || a.Id,
              name: a.Name || a.name || a.Filename
            })),
            statuses: {
              sent: sentCount,
              sending: sendingCount,
              failed: failedCount
            },
            recipientCount: recipients.length,
            status: `${sendingCount} <span class="text-primary">Sending</span><br>
              ${sentCount} <span class="text-success">Sent</span><br>
              ${failedCount} <span class="text-danger">Failed</span>`
          };
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  newEmail() {
    this.$state.go('.create');
  }

  openEmailDetailsModal(email: any) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.email = email;

    this.$mdDialog.show({
      template: '<md-dialog flex="80"><email-details-dialog email="email"></email-details-dialog></md-dialog>',
      scope: tempScope,
      clickOutsideToClose: true,
      escapeToClose: true
    });
  }
}

export const emails: angular.IComponentOptions = {
  controller: EmailsController,
  template: require('./emails.html')
}



// WEBPACK FOOTER //
// ./src/app/bulkemailing/views/emails.ts